var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    transform: "translate(0.118896)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38723 24.9937C8.05885 24.9937 7.85046 24.9621 7.8252 24.9558L8.14095 23.0866C8.27988 23.1118 11.6584 23.5539 12.593 17.9209C13.9697 9.66086 15.6432 8.30313 16.9441 8.04421C18.0808 7.81687 19.1796 8.5431 20.2089 10.1913C22.5707 13.9803 23.3538 13.9487 25.4441 13.8666C25.8924 13.8477 26.3913 13.8288 26.966 13.8351L26.9344 15.7296C26.4103 15.7169 25.943 15.7422 25.5198 15.7548C22.836 15.8622 21.4214 15.7169 18.6049 11.1891C17.9229 10.1029 17.4619 9.87557 17.3167 9.90083C17.2535 9.91346 15.7821 10.2924 14.4623 18.2366C14.0076 20.9647 12.9782 22.9097 11.4058 24.0275C10.2375 24.8548 9.06294 25 8.38723 25V24.9937Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62719 24.0528H7.16211",
    strokeWidth: 1.8945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42277 14.1887H6.9978V15.4517H9.42277V14.1887Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9191 14.1887H11.4941V15.4517H13.9191V14.1887Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.331 14.1887H16.906V15.4517H19.331V14.1887Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9681,
    height: 17,
    fill: "white",
    transform: "translate(6.9978 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRip);
export default __webpack_public_path__ + "static/media/rip.9b3c926cae84dc07bc492a99abebfa82.svg";
export { ForwardRef as ReactComponent };